import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import classnames from 'classnames'
import dayjs from '../../../../utils/dayjs'
import getRoutePath from '../../../utils/getRoutePath'
import keyUpHandler from '../../../utils/keyUpHandler'

import './styles.css'

class BookmarkedTutorial extends Component {
  constructor(props) {
    super(props)
    this.state = { visible: false }
    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    this.setState({ visible: !this.state.visible })
  }

  render() {
    const { props } = this
    const { visible } = this.state
    const userBookmarks = _.filter(props.bookmarks, { autoGenerated: false })

    return (
      <div className="bookmarked-tutorial">
        <div
          aria-label="Toggle bookmarks list"
          className="bookmark-summary"
          onClick={() => this.toggle()}
          onKeyUp={event => keyUpHandler(event, this.toggle, null, this)}
          tabIndex={0}
          role="button"
        >
          {_.has(props, 'photo.bookmarkThumb') && (
            <div className="thumbnail">
              <img src={props.photo.bookmarkThumb} alt={props.title} />
            </div>
          )}
          <div className="tutorial">
            <div className="tutorial-description">
              <div className="tutorial-title" onClick={(e) => e.stopPropagation()} role="presentation">
                <Link to={`/tutorials/${props.slug}`}>{props.title}</Link>
              </div>
              <div className="tutorial-author">
                By <Link to={`/artists/${props.artist.slug}`}>{props.artist.title}</Link>
              </div>
            </div>
          </div>
          <div className="amount">
            <span>{_.size(userBookmarks)}</span>
          </div>
          <button
            type="button"
            aria-label={visible ? 'Collapse' : 'Expand'}
            className={classnames('button', { animate: visible })}
          >
            <i className="icon-right-2 button__icon" />
          </button>
        </div>
        {visible && (
          <div className="bookmarks">
            {userBookmarks.map((bookmark) => (
              <div
                key={bookmark.id}
                aria-label="Load bookmark"
                className="bookmark"
                onClick={() => props.loadBookmark(props.slug, bookmark, getRoutePath(window.location.href))}
                onKeyUp={event => keyUpHandler(event, props.loadBookmark, null, null, [props.slug, bookmark, getRoutePath(window.location.href)])}
                tabIndex={0}
                role="button"
              >
                <div className="bookmark-body">
                  <div className="filler" />
                  <i className="icon icon-bookmark-filled blue" />
                  <div className="name">{_.isEmpty(bookmark.name) ? 'Unnamed bookmark' : bookmark.name}</div>
                  <div className="time">{`Chapter ${bookmark.chapterOrder} - ${dayjs.duration(bookmark.time, 'seconds').format('H:mm:ss')}`}</div>
                  <div
                    aria-label="Remove bookmark"
                    className="remove"
                    onClick={(e) => props.removeBookmark(e, bookmark.id)}
                    onKeyUp={event => keyUpHandler(event, props.removeBookmark, null, null, [event, bookmark.id])}
                    tabIndex={0}
                    role="button"
                  >
                    <span>x</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    )
  }
}

BookmarkedTutorial.propTypes = {
  bookmarks: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string,
    chapterOrder: PropTypes.number,
    time: PropTypes.number,
    autoGenerated: PropTypes.bool
  })),
  photo: PropTypes.shape({
    bookmarkThumb: PropTypes.string
  }),
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  artist: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  }).isRequired,
  loadBookmark: PropTypes.func.isRequired,
  removeBookmark: PropTypes.func.isRequired
}

BookmarkedTutorial.defaultProps = {
  bookmarks: [],
  photo: {}
}

export default BookmarkedTutorial
